export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/edit.f9432889.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};